import React, { useEffect, useState } from "react";
import { Phone, MessageCircle, ArrowUp } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const FloatingButtons = () => {
    const { settings } = useSettings();
    const [showTop, setShowTop] = useState(false);

    useEffect(() => {
        const onScroll = () => setShowTop(window.scrollY > 400);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (!settings) return null;
    const wa = (settings.whatsapp || settings.phone).replace(/[^\d]/g, "");

    return (
        <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3 items-end">
            {showTop && (
                <button
                    data-testid="scroll-top-btn"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    className="w-11 h-11 grid place-items-center rounded-full bg-white/10 backdrop-blur-md text-white border border-white/20 hover:bg-gold hover:text-black hover:border-gold transition-all duration-300"
                    aria-label="Scroll to top"
                >
                    <ArrowUp size={18} />
                </button>
            )}
            <a
                href={`tel:${settings.phone}`}
                data-testid="floating-call-btn"
                className="w-13 h-13 p-3.5 rounded-full grid place-items-center text-black shadow-[0_10px_30px_-8px_rgba(212,175,55,0.6)] hover:scale-110 transition-transform"
                style={{ background: "linear-gradient(135deg, #F1D570, #D4AF37)" }}
                aria-label="Call now"
            >
                <Phone size={22} />
            </a>
            <a
                href={`https://wa.me/${wa}?text=Hello%20Star%20Events,%20I%20want%20to%20enquire%20about%20your%20event%20services`}
                target="_blank" rel="noreferrer"
                data-testid="floating-whatsapp-btn"
                className="w-13 h-13 p-3.5 rounded-full grid place-items-center bg-[#25D366] text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,0.7)] hover:scale-110 transition-transform"
                aria-label="WhatsApp"
            >
                <MessageCircle size={22} />
            </a>
        </div>
    );
};

export default FloatingButtons;
